import StageEstimatedTime from './styled';

export default StageEstimatedTime;
